import { Box, Tab, Tabs, withStyles } from "@material-ui/core";
import List from "@material-ui/core/List";
import React from "react";
import Component from "src/components/Component";
import withAxios from "src/components/withAxios";
import SeasonSportListItem from "../season-sport-list-item/SeasonSportListItem";
import SeasonsEditor from "../seasons-editor/SeasonsEditor";
import { ALL_SEASONS } from "./constants";
import { styles } from "./styles";
import { IProps, ISeasonsPageState } from "./types";

export default withStyles(styles)(
  withAxios(
    class extends Component<IProps, ISeasonsPageState> {
      public readonly state = this.buildState({
        selectedSeasonName: ALL_SEASONS,
      });

      public render() {
        const {
          classes,
          defaultSeasons,
          loadSeasons,
          loadingSeasonsResponse,
          openDefaultSettingsModal,
          seasons,
          seasonsChange,
          schoolId,
          setSeason,
          sports,
          school,
        } = this.props;
        const { selectedSeasonName } = this.state;
        const selectedSeason = seasons.find(
          (season) => season.name === selectedSeasonName
        );
        
        const isAdSurvey = school?.isAdSurvey;
        const adSurveysSportIds = [72, 74, 73, 68];
        
        // Filter sports based on whether it's ISME ad survey or not
         let sportsByContext: any[] = [];

         if(school){
             sportsByContext = isAdSurvey
          ? sports.filter((sport) => adSurveysSportIds.includes(sport.id))
          : sports.filter((sport) => !adSurveysSportIds.includes(sport.id));

         }else{
              sportsByContext = sports;
}
        const filteredSports =
          selectedSeason === undefined
            ? sportsByContext
            : sportsByContext.filter((sport) =>
                selectedSeason.sportIds.includes(sport.id)
              );

        const setSelectedSeason = (seasonName: string) => {
          this.setState({ selectedSeasonName: seasonName });
        };

        const handleChange = (_: React.ChangeEvent<{}>, newValue: string) => {
          setSelectedSeason(newValue);
        };

        return (
          <>
            <Box
              alignItems="center"
              display="flex"
              flexWrap="wrap"
              gridGap="1rem"
              justifyContent="space-between"
            >
              <Tabs
                className={classes.tabs}
                value={selectedSeasonName}
                onChange={handleChange}
                indicatorColor="primary"
                textColor="primary"
              >
                <Tab
                  className={classes.tabOverride}
                  label={ALL_SEASONS}
                  value={ALL_SEASONS}
                />
                {seasons.map((season) => (
                  <Tab
                    className={classes.tabOverride}
                    key={season.id}
                    label={season.name}
                    value={season.name}
                  />
                ))}
              </Tabs>
              <Box>
                <SeasonsEditor
                  setSeason={setSeason}
                  defaultSeasons={defaultSeasons}
                  schoolId={schoolId}
                  seasons={seasons}
                  loadingSeasonsResponse={loadingSeasonsResponse}
                  loadSeasons={loadSeasons}
                  openDefaultSettingsModal={openDefaultSettingsModal}
                  seasonsChange={seasonsChange}
                />
              </Box>
            </Box>
            <List>
              {filteredSports.map((sport) => {
                const selectedSeason = seasons.find((season) =>
                  season.sportIds.includes(sport.id)
                );
                return (
                  <SeasonSportListItem
                    loadSeasons={loadSeasons}
                    defaultSeasons={defaultSeasons}
                    schoolId={schoolId}
                    selectedSeason={selectedSeason}
                    seasons={seasons}
                    key={sport.id}
                    sport={sport}
                    seasonsChange={seasonsChange}
                  />
                );
              })}
            </List>
          </>
        );
      }
    }
  )
);



// WEBPACK FOOTER //
// ./src/pages/director/seasons/components/seasons-sport-editor/SeasonsSportEditor.tsx